import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FileText, MessageSquare, CalendarCheck, Lock } from 'lucide-react';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
export function OrangTua() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      alert('Permintaan konsultasi berhasil dikirim. Guru BK akan segera menghubungi Anda untuk konfirmasi jadwal.');
      (e.target as HTMLFormElement).reset();
    }, 1000);
  };
  return <div className="min-h-screen bg-white py-12" data-id="element-444">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-445">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-446">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} data-id="element-447">
            <h1 className="text-4xl font-bold text-dark mb-6" data-id="element-448">
              Layanan Orang Tua
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-449">
              Kolaborasi antara sekolah dan orang tua adalah kunci keberhasilan
              peserta didik. Kami menyediakan layanan khusus untuk memfasilitasi
              komunikasi dan pemantauan perkembangan anak Anda.
            </p>
          </motion.div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-450">
          {/* Rapor Perkembangan */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.1
        }} className="space-y-8" data-id="element-451">
            <div className="bg-pastel-blue-light/30 rounded-3xl p-8 border border-pastel-blue-light" data-id="element-452">
              <div className="flex items-center gap-4 mb-6" data-id="element-453">
                <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center shadow-sm" data-id="element-454">
                  <FileText className="text-blue-600 w-7 h-7" data-id="element-455" />
                </div>
                <h2 className="text-2xl font-bold text-dark" data-id="element-456">
                  Rapor Perkembangan Anak
                </h2>
              </div>
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-457">
                Pantau perkembangan akademik, sosial, dan emosional anak Anda
                melalui catatan berkala dari Guru BK. Data ini bersifat rahasia
                dan hanya dapat diakses oleh orang tua/wali yang bersangkutan.
              </p>

              <div className="bg-white rounded-2xl p-6 border border-pastel-grey flex flex-col items-center justify-center text-center py-12" data-id="element-458">
                <Lock className="text-gray-400 w-12 h-12 mb-4" data-id="element-459" />
                <h3 className="text-lg font-semibold text-dark mb-2" data-id="element-460">
                  Akses Terbatas
                </h3>
                <p className="text-sm text-gray-500 mb-6 max-w-xs" data-id="element-461">
                  Hubungi Wali Kelas atau Guru BK untuk mendapatkan kode akses
                  rapor perkembangan anak Anda.
                </p>
                <Button variant="outline" data-id="element-462">Masukkan Kode Akses</Button>
              </div>
            </div>
          </motion.div>

          {/* Form Konsultasi */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-463">
            <div className="bg-white rounded-3xl p-8 border border-pastel-grey shadow-apple" data-id="element-464">
              <div className="flex items-center gap-4 mb-8" data-id="element-465">
                <div className="w-14 h-14 rounded-2xl bg-pastel-pink-light flex items-center justify-center" data-id="element-466">
                  <MessageSquare className="text-pink-600 w-7 h-7" data-id="element-467" />
                </div>
                <div data-id="element-468">
                  <h2 className="text-2xl font-bold text-dark" data-id="element-469">
                    Konsultasi Orang Tua
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-470">
                    Jadwalkan pertemuan dengan Guru BK
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5" data-id="element-471">
                <Input label="Nama Orang Tua / Wali" required placeholder="Masukkan nama lengkap Anda" data-id="element-472" />

                <div className="grid grid-cols-2 gap-4" data-id="element-473">
                  <Input label="Nama Anak" required placeholder="Nama lengkap anak" data-id="element-474" />
                  <Input label="Kelas Anak" required placeholder="Contoh: X IPA 1" data-id="element-475" />
                </div>

                <Input label="No. HP / WhatsApp" type="tel" required placeholder="08..." data-id="element-476" />

                <Input label="Topik Konsultasi" as="select" required options={[{
                label: 'Perkembangan Akademik',
                value: 'akademik'
              }, {
                label: 'Perilaku & Sosial',
                value: 'sosial'
              }, {
                label: 'Perencanaan Karier/Kuliah',
                value: 'karier'
              }, {
                label: 'Kesehatan Mental Anak',
                value: 'mental'
              }, {
                label: 'Lainnya',
                value: 'lainnya'
              }]} data-id="element-477" />

                <Input label="Pesan Tambahan (Opsional)" as="textarea" placeholder="Ceritakan secara singkat hal yang ingin didiskusikan..." data-id="element-478" />

                <Input label="Rencana Jadwal Konsultasi" type="datetime-local" required data-id="element-479" />

                <div className="pt-4" data-id="element-480">
                  <Button type="submit" fullWidth size="lg" isLoading={isSubmitting} data-id="element-481">
                    <CalendarCheck size={20} className="mr-2" data-id="element-482" /> Ajukan Jadwal
                    Konsultasi
                  </Button>
                </div>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}